import { render, staticRenderFns } from "./bridgeDetails.vue?vue&type=template&id=66e81c6a&scoped=true"
import script from "./bridgeDetails.vue?vue&type=script&lang=js"
export * from "./bridgeDetails.vue?vue&type=script&lang=js"
import style0 from "./bridgeDetails.vue?vue&type=style&index=0&id=66e81c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e81c6a",
  null
  
)

export default component.exports